// extracted by mini-css-extract-plugin
module.exports = {"container":"MoneyGraph_container__2E3nP","title":"MoneyGraph_title__3x66K","noDataAvailable":"MoneyGraph_noDataAvailable__q-pdM"};